import Swal from 'sweetalert2'

export default {
  install: (app) => {
    
    app.config.globalProperties.$chooseOption = async (description, optionsList = [], options = {}) => {
      if (!Array.isArray(optionsList) || optionsList.length === 0) return null

      const selectOptions = {}
      optionsList.forEach((opt, i) => {
        selectOptions[opt.key] = opt.value // clave = índice, valor = texto
      })

      const { value } = await Swal.fire({
        title: '',
        text: description || 'Seleccione una opción',
        input: 'select',
        inputOptions: selectOptions,
        inputPlaceholder: options.placeholder || 'Seleccione...',
        showCancelButton: true,
        confirmButtonText: 'Aceptar',
        cancelButtonText: 'Cancelar',
        confirmButtonColor: localStorage.getItem('color_base') || '#fd7527' ,
        customClass: {
          popup: 'text-sm',
          confirmButton: 'text-sm',
          cancelButton: 'text-sm'
        },
        ...options
      })

      if (value === undefined) return null // canceló
      return parseInt(value)
    }
  }
}
